import React from 'react';
import PropTypes from 'prop-types';
import './UserProfile.scss';
import request from '../../utils/agent';
import ResellerProfile from './ResellerProfile';
import DistributorProfile from './DistributorProfile';
import EmployeeProfile from './EmployeeProfile';
import DevArchProfile from './DevArchProfile';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';



export default class UserProfile extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            role: "",
            loaded: false,
        };
    }

    componentDidMount() {
        this.getRoleData();
        this.loadGoogleMaps();
    }

    loadGoogleMaps = () => {
        var script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAf6G6eJvy-QDsPf9-ssNiykkMH89Fbbgo&libraries=places";
        document.getElementsByTagName('head')[0].appendChild(script);
    };

    getRoleData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        role: resp.body.user.role,
                        loaded: true,
                    });
                    resolve(resp.body);
                });
        });
    };


    render() {

        //console.log('role', this.state.role.name);



        return(
            <section className='profile--container'>
                <h1>Profile</h1>
                {this.state.loaded === true ?
                    <div>
                        {this.state.role.name === 'user' || this.state.role.name === 'electrician' ?
                            <ResellerProfile/> :
                            null
                        }
                        {this.state.role.name === 'installer' ?
                            <EmployeeProfile/> :
                            null
                        }
                        {this.state.role.name === 'distributor' ?
                            <DistributorProfile/> :
                            null
                        }
                        {this.state.role.name === 'developer' || this.state.role.name === 'architect' || this.state.role.name === 'ownermanager' ?
                            <DevArchProfile/> :
                            null
                        }
                    </div> :
                    <Loader/>
                }
            </section>
        );
    }
};


// WEBPACK FOOTER //
// ./src/routes/UserProfile/index.js